import { QueryOperator } from '../types/query-operator';
import { LogicalOperator } from '../types/logical-operator';

export class FilterItem {
    public propertyName: string;
    public operator: QueryOperator;
    public logicalOperator: LogicalOperator;
    public value: any;
}
